module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "console"
  }, [_c('div', [_c('input', {
    staticClass: "input-eng u-full-width",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.osacian
    },
    on: {
      "keyup": [_vm.onInput, function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.process($event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "outputcontianer"
  }, _vm._l((_vm.output), function(msg) {
    return _c('div', {
      class: msg.style
    }, [_vm._v("\n      " + _vm._s(msg.print) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1ea6bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/special/34.min.vue
// module id = 271
// module chunks = 1